<!-- დაზღვევის ტიპი  -->
<div class="filled" [ngClass]="!editModeMap[4] ? 'success' : 'danger'">
  <div class="row align-items-center filled-row justify-content-xs-center" *ngIf="!editModeMap[4]">
    <div class="col filled-title">
      სადაზღვევო პროდუქტი
    </div>
    <div class="col-lg-2 col-12">
      <div class="d-flex flex-column">
        <p>{{this.policy.InsuranceType.type | translate}}</p>
        <p *ngIf="this.policy.PolicyType.franchise === true">ფრანშიზით</p>
        <p *ngIf="this.policy.PolicyType.covid === true">კოვიდით</p>
        <p>{{this.policy.PolicyType.policy | translate}}</p>
      </div>
    </div>
    <div class="col-lg-2 col-12 text-center">
      <span class="currency">
        {{insurance.currency}}
      </span>
    </div>
    <div class="col edit-btn">
      <button class="ml-m@s g-b--w0 g g--alignCenter g--nowrap cur-p edit ms-auto d-flex" (click)="onEdit(4)">
        <div class="mr-xs fz-12" style="color: #737373;">ცვლილება</div>
        <i class="fas fa-pen"></i>
      </button>
    </div>
  </div>
  <form [formGroup]="form">
    <div class="row edit-row position-relative align-items-center" *ngIf="editModeMap[4]">
      <div class="col-lg-3 col-12">
        <label for="">დაზღვევის ტიპი</label>
        <p>{{this.policy.InsuranceType.type | translate}}</p>
      </div>
      <div class="col-lg-3 mobile-space edit-checkbox">
        <div class="d-flex flex-lg-column">
          <div class="left">
            <mat-checkbox formControlName="franchise" class="example-margin">ფრანშიზა</mat-checkbox>
          </div>
          <div class="right">
            <mat-checkbox formControlName="covid" class="example-margin">კოვიდ 19 დაფარვა</mat-checkbox>
          </div>
        </div>
      </div>
      <div class="col-lg-6 col-12 mobile-space">
        <label for="">პოლისი</label>
        <div class="row">
          <div class="col-lg-8 col-8">
            <select class="form-select" aria-label="Default select example" formControlName="policy">
              <option value="standart">სტანდარტი</option>
              <option value="comfort">კომფორტი</option>
              <option value="premium">პრემიუმი</option>
            </select>
          </div>
          <div class="col-lg-2 p col-2">
            <div class="hidden-radio h-100">
              <input type="radio" formControlName="currency" value="$" id="dollar"><label for="dollar">
                $</label>
            </div>
          </div>
          <div class="col-lg-2 p col-2">
            <div class="hidden-radio h-100">
              <input type="radio" formControlName="currency" value="€" id="euro"><label for="euro">
                €</label>
            </div>
          </div>
        </div>
      </div>
      <div class="done" (click)="done(4)">
        შენახვა
      </div>
    </div>
  </form>
</div>
<!-- დაზღვევის ტიპი  -->
